import { render, staticRenderFns } from "./CaseCard.vue?vue&type=template&id=0998db67"
import script from "./CaseCard.vue?vue&type=script&lang=js"
export * from "./CaseCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports